export { default } from './getDisplayName';
export * from './getDisplayName';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/getDisplayName/index.js
// module id = 254
// module chunks = 22